/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Textarea,
} from '@mybridge/ui';
import { forwardRef, useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { MyProfileContext } from '../context';
import { DateSelect } from 'v4/components/date-select';
import { useDisclosure } from '@mybridge/ui';
import { CreateAudiencePermissionModal } from '../audience-modal-create';
import { EarthGlobeIcon, OnlyMeLockIcon, TeamIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfileCertificateModal = forwardRef(({ ...props }, ref) => {
  const {
    certificatesDisc,
    addCertificate,
    addCertificateLoading,
    selectedCertificate,
    updateCertificate,
    setSelectedCertificate,
    removeCertificate,
    removeCertificateLoading,
    isDateAfter,
  } = useContext(MyProfileContext);
  const audienceCreateDisc = useDisclosure();
  const { t } = useTranslator();
  const [audienceValue, setAudienceValue] = useState(1);
  const certificate = {
    ...(selectedCertificate ?? {}),
    start_date: {
      month: parseInt(selectedCertificate?.start_month ?? '0'),
      year: selectedCertificate?.start_year,
    },
    end_date: {
      month: parseInt(selectedCertificate?.end_month ?? '0'),
      year: selectedCertificate?.end_year,
    },
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: certificate ?? {},
  });

  const onSubmit = async (form) => {
    const payload = {
      ...(form ?? {}),
      start_month: form?.start_date?.month,
      start_year: form?.start_date?.year,
      end_month: form?.end_date?.month,
      end_year: form?.end_date?.year,
      audience: audienceValue,
    };
    if (selectedCertificate?.id) {
      await updateCertificate({
        id: selectedCertificate?.id,
        ...(payload ?? {}),
      });
    } else {
      await addCertificate(payload);
    }
  };

  const onClose = () => {
    certificatesDisc?.onClose();
    setSelectedCertificate?.(null);
  };

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
    }
  };

  return (
    // <Modal size="xl" {...(certificatesDisc ?? {})} onClose={onClose}>
    //   <ModalOverlay />
    //   <ModalContent>

    //   </ModalContent>
    // </Modal>
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Heading fontSize="18px"
          color="brandPrimary.500"
          fontWeight="400"
          mb={4}>
          {t('profileCertificates.certificationsAndAwards') || "Certifications & Awards"}
        </Heading>
        {/* <ModalBody> */}
          <Stack spacing={4}>
            <FormControl isInvalid={errors?.cert_name} variant="floating">
              <Input {...register('cert_name', { required: true })} textTransform="capitalize" />
              <FormLabel>{t('profileCertificates.certificationName') || "Certification Name"}*</FormLabel>
              <FormErrorMessage>
                {t('profileCertificates.certificationNameRequired') || "Certification name is required"}
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors?.cert_authority} variant="floating">
              <Input {...register('cert_authority')} textTransform="capitalize"/>
              <FormLabel>{t('profileCertificates.certificationAuthority') || "Certification Authority"}</FormLabel>
              <FormErrorMessage>
                {t('profileCertificates.certificationAuthorityRequired') || "Certification authority is required"}
              </FormErrorMessage>
            </FormControl>
            <FormControl variant="floating">
              <Input {...register('license_number')} />
              <FormLabel>{t('profileCertificates.licenseNumber') || "License Number"}</FormLabel>
            </FormControl>
            <FormControl variant="floating" isInvalid={errors?.cert_url}>
              <Input {...register('cert_url', {required:false, pattern:
                          /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/i,})} />
              <FormLabel>{t('profileCertificates.certificationUrl') || "Certification URL"}</FormLabel>
              <FormErrorMessage>{t('profileCertificates.validUrlRequired') || "Please enter valid url including https"}</FormErrorMessage>
            </FormControl>
            <HStack alignItems="flex-start">
              <FormControl isInvalid={errors?.start_date}>
                <FormLabel sx={{mb:"6px"}}>{t('profileExperience.startDate') || "Start date"}</FormLabel>
                <Controller
                  control={control}
                  render={({ field }) => (
                    <DateSelect
                      variant="floating"
                      yearsCount={200}
                      flex={1}
                      {...field}
                    />
                  )}
                  rules={{ required: false }}
                  name="start_date"
                />
                <FormErrorMessage>{t('profileExperience.startDateRequired') || "Start date is required"}</FormErrorMessage>
              </FormControl>
              {!watch('cert_not_expire') ? (
                <FormControl isInvalid={errors?.end_date}>
                  <FormLabel sx={{mb:"6px"}}>{t('profileExperience.endDate') || "End date"}</FormLabel>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect
                        variant="floating"
                        yearsCount={200}
                        flex={1}
                        {...field}
                      />
                    )}
                    rules={{
                      required: false,
                      validate() {
                        return isDateAfter(
                          watch('start_date')?.month,
                          watch('start_date')?.year,
                          watch('end_date')?.month,
                          watch('end_date')?.year
                        );
                      },
                    }}
                    name="end_date"
                  />
                  <FormErrorMessage>{t('profileCertificates.validEndDateRequired') || "Enter a valid end date"}</FormErrorMessage>
                </FormControl>
              ) : (
                ''
              )}
            </HStack>
            <FormControl>
              <Checkbox {...register('cert_not_expire')}>
                {t('profileCertificates.doesNotExpire') || "This certificate doesn't expire"}
              </Checkbox>
            </FormControl>
          </Stack>
        {/* </ModalBody>
        <ModalFooter> */}
          <HStack flex={1} mt={4}>
          <HStack flex={1} justifyContent="flex-start">
            <Button
              borderRadius="50px"
              leftIcon={renderPermissionSwitch(audienceValue)?.icon}
              type="button"
              onClick={() => {
                audienceCreateDisc.onOpen();
              }}
            >
              {renderPermissionSwitch(audienceValue)?.text}
            </Button>
            {selectedCertificate?.id ? (
              <Button
                borderRadius="50px"
                onClick={(e) => removeCertificate(selectedCertificate)}
                isLoading={removeCertificateLoading}
                color="red.500"
                variant="ghost"
              >
                {t('buttons.delete') || 'Delete'}
              </Button>
            ) : (
              ''
            )}
          </HStack>
            

            <HStack flex={1} justifyContent="flex-end">
              <Button
              borderRadius="50px"
                onClick={(e) => certificatesDisc?.onClose?.()}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={addCertificateLoading}
                type="submit"
                variant="primary"
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        {/* </ModalFooter> */}
      </form>
      {audienceCreateDisc?.isOpen ? (
        <CreateAudiencePermissionModal
          {...audienceCreateDisc}
          setPermissionValue={(e) => setAudienceValue(e)}
        />
      ) : (
        ''
      )}
    </>
  );
});
